import { FormEvent, useState } from "react";

import { placeFacts } from "./placeFacts";

const valueList = (value: any) => (Array.isArray(value) ? value.filter(Boolean).join(", ") : value);

export const StartResearchDialog = ({
  parcel,
  onClose,
  onStart,
  busy,
  initialQuestion = "",
}: {
  parcel: any;
  onClose: () => void;
  onStart: (question: string) => void;
  busy: boolean;
  initialQuestion?: string;
}) => {
  const [question, setQuestion] = useState(initialQuestion);
  const data = parcel.data || {};
  const layers = data.data || {};
  const address = data.addresses?.[0];
  const submit = (event: FormEvent) => {
    event.preventDefault();
    onStart(question.trim());
  };

  const facts = [
    ["Oppervlakte", parcel.area ? `${Math.round(parcel.area).toLocaleString("nl-NL")} m²` : null],
    ["Adres", address && `${address.street} ${address.number}, ${address.city}`],
    ...placeFacts(parcel.place),
    ["Bestemming", valueList(layers.zoningSingle?.map((item: any) => item.name))],
    [
      "Dubbelbestemming",
      valueList(layers.zoningDouble?.map((item: any) => item.data?.naam || item.name)),
    ],
    ["Grondgebruik", valueList(layers.landCover?.map((item: any) => item.name))],
    [
      "Bebouwing",
      data.builtUp?.buildings?.length ? `${data.builtUp.buildings.length} pand(en)` : null,
    ],
  ].filter(([, value]) => value);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
      <form onSubmit={submit} className="w-full max-w-lg rounded-lg bg-white p-5 shadow-xl">
        <h2 className="text-lg font-bold">Kavelonderzoek starten</h2>
        <p className="mt-1 text-sm font-semibold">{parcel.name}</p>
        <dl className="mt-3 grid grid-cols-[8rem_1fr] gap-x-3 gap-y-1 text-xs">
          {facts.map(([label, value]) => (
            <div key={label as string} className="contents">
              <dt className="text-gray-500">{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-4 text-xs text-gray-600">
          We onderzoeken ruimtelijke plannen, bodem, water en klimaat, natuur, erfgoed,
          bereikbaarheid en publieke ontwikkelplannen via openbare webbronnen.
        </p>
        <label className="mt-4 block text-xs font-semibold" htmlFor="research-question">
          Extra onderzoeksvraag (optioneel)
        </label>
        <textarea
          id="research-question"
          value={question}
          onChange={(event) => setQuestion(event.target.value)}
          rows={3}
          className="mt-1 w-full rounded border border-gray-300 p-2 text-sm"
          placeholder="Bijvoorbeeld: beoordeel vooral de geschiktheid voor woningbouw."
        />
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded px-3 py-2 text-sm">
            Annuleren
          </button>
          <button
            type="submit"
            disabled={busy}
            className="rounded bg-bright-yellow px-4 py-2 text-sm font-bold hover:bg-yellow disabled:opacity-50"
          >
            {busy ? "Starten…" : "Start onderzoek"}
          </button>
        </div>
      </form>
    </div>
  );
};
